import classNames from 'classnames';
import { FunctionComponent, ReactNode } from 'react';
import type { FallbackProps } from 'react-error-boundary';
import { ClassName } from 'types/ClassName';
import { t } from 'utils/localize';
import './DetailsItem.scss';
import DetailsItemWrapper from './DetailsItemWrapper/DetailsItemWrapper';

export interface IDetailsItemProps {
  onClick: () => void;
  children?: ReactNode;
  disabled?: boolean;
  title?: string;
  hint?: string;
  value?: string | null;
  emptyValue?: string;
  hideArrow?: boolean;
  rightContent?: ReactNode;
  className?: ClassName;
  preserveWhitespace?: boolean;
}

const DetailsItem: FunctionComponent<IDetailsItemProps> = (props) => {
  const { title, value, emptyValue = '---', className, children, preserveWhitespace = false, ...wrapperProps } = props;
  const classes = classNames('details-item', className);

  return (
    <DetailsItemWrapper className={classes} {...wrapperProps}>
      {title && <div className="details-item-title">{title}</div>}
      <div className="details-item-value pr-8" style={preserveWhitespace ? { whiteSpace: 'pre-line' } : undefined}>
        {'value' in props ? value || emptyValue : ''}
        {children}
      </div>
    </DetailsItemWrapper>
  );
};

export const DetailsItemErrorCard: React.FC<FallbackProps & { title: string }> = ({ title, error }) => {
  return <DetailsItem title={t(title)} value={error.toString()} onClick={() => null} />;
};

export default DetailsItem;
